import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import { fetchSurveysSuccess, showSurveyMessage, onSaveSurveySuccess } from 'actions/Survey';
import { ON_SAVE_SURVEY, FETCH_ALL_SURVEY } from 'constants/ActionTypes';
import { update, post } from 'services/ApiClient';
import { endpoint } from 'services/ApiConfig';
import { fetchDataRequest } from 'services/ApiService';

const fetchSurveysRequest = async () => {
    return fetchDataRequest('surveys');
};

function* fetchSurveys() {
    try {
        const fetchedSurveys = yield call(fetchSurveysRequest) || [];
        yield put(fetchSurveysSuccess(fetchedSurveys));
    } catch (error) {
        yield put(showSurveyMessage(error.messages));
    }
}

const getSurveyList = (state) => state.surveys.surveyList;

function* saveSurvey({ payload }) {
    try {
        const allSurveys = yield select(getSurveyList);
        const savedSurveys = yield call(saveSurveyRequest, allSurveys, payload);
        yield put(onSaveSurveySuccess(savedSurveys));
    } catch (error) {
        yield put(showSurveyMessage(error.messages));
    }
}

const saveSurveyRequest = async (allSurveys, payload) => {
    try {
        let isNew = true;
        const surveyList = allSurveys.map((survey) => {
            if (survey.id === payload.id) {
                isNew = false;
                return payload;
            } else {
                return survey;
            }
        });

        const endpointConfig = isNew ? endpoint('addSurvey') : endpoint('updateSurvey');
        if (isNew) {
            // eslint-disable-next-line no-unused-vars
            if (endpointConfig) {
                await post(endpointConfig.uri, payload)
                    .then((response) => {
                        // the response will return the id so place it back into the local object
                        const id = response ? response.id : 'addSurveyResponseError';
                        const updatedPayload = { ...payload, id: id };
                        surveyList.push(updatedPayload);
                    })
                    .catch(error => {
                        throw error;
                    });
            }
        } else {
            if (endpointConfig) {
                await update(endpointConfig.uri, payload)
                    .then(payload => payload) // already in list
                    .catch(error => {
                        throw error;
                    });
            }
        }
        return surveyList;
    } catch (error) {
        throw error;
    }
};

export function* fetchSurveysSaga() {
    yield takeEvery(FETCH_ALL_SURVEY, fetchSurveys);
}

export function* saveSurveySaga() {
    yield takeEvery(ON_SAVE_SURVEY, saveSurvey);
}

export default function* rootSaga() {
    yield all([fork(fetchSurveysSaga), fork(saveSurveySaga)]);
}


// WEBPACK FOOTER //
// ./sagas/Survey.js